var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "mb-4" },
      [
        _c("router-link", { attrs: { to: { name: "categories" } } }, [
          _c("h3", [_vm._v("← Back to categories")]),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-4", class: { invisible: !this.initializedForm } },
      [
        !_vm.isEdit
          ? _c("h1", { staticClass: "mt-2 mb-4 font-sans text-n-gray-dark" }, [
              _vm._v("Add Category"),
            ])
          : _c("h1", { staticClass: "mt-2 mb-4 font-sans text-n-gray-dark" }, [
              _vm._v("Edit Category"),
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex flex-wrap" }, [
          _c("div", { staticClass: "w-full mb-3 md:mb-0 md:pr-5" }, [
            _c("label", { staticClass: "sr-only", attrs: { for: "title" } }, [
              _vm._v("Enter category name"),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.title,
                  expression: "form.title",
                },
              ],
              attrs: {
                id: "title",
                type: "text",
                name: "title",
                placeholder: "Enter category name",
              },
              domProps: { value: _vm.form.title },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "title", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-full mb-3 md:mb-0 md:pr-5 pt-2" }, [
            _c("label", { staticClass: "sr-only", attrs: { for: "slug" } }, [
              _vm._v("Enter category slug from Craft"),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.slug,
                  expression: "form.slug",
                },
              ],
              attrs: {
                id: "slug",
                type: "text",
                name: "slug",
                placeholder: "Enter category slug from Craft",
              },
              domProps: { value: _vm.form.slug },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "slug", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-full mb-3 md:mb-0 md:pr-5 pt-2" }, [
            _c(
              "label",
              { staticClass: "sr-only", attrs: { for: "category-group" } },
              [_vm._v("Select Category Group")]
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.category_group_id,
                    expression: "form.category_group_id",
                  },
                ],
                class: { placeholder: _vm.form.category_group_id === null },
                attrs: { id: "category-group" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.form,
                      "category_group_id",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                },
              },
              [
                _c("option", { attrs: { value: "", disabled: "" } }, [
                  _vm._v("-- Select Category Group --"),
                ]),
                _vm._v(" "),
                _vm._l(_vm.categoryGroups, function (group) {
                  return _c(
                    "option",
                    { key: group.id, domProps: { value: group.id } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(group.title) +
                          "\n                    "
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-full md:w-1/4 pt-2 pb-4" }, [
            _c(
              "button",
              {
                staticClass: "button w-full",
                attrs: { type: "button" },
                on: { click: _vm.saveCategory },
              },
              [_vm._v("Save")]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }